import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "app-report-footer-default",
    templateUrl: "./report-footer-default.component.html",
    styleUrls: ["./report-footer-default.component.scss"],
    standalone: false
})
export class ReportFooterDefaultComponent extends BaseControlComponent implements OnInit {
    static componentName = "ReportFooterDefaultComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
    }

}
